import { getLocaleInfo } from './info';

export default function numberSymbols(locale) {
    var info = getLocaleInfo(locale);

    return info.numbers.symbols;
}


//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/cldr/number-symbols.js
// module id = 867
// module chunks = 93